import React from 'react';

import { DefaultComponentProps } from '../../../types';

import { CardBody } from '../../../components/CardBody';
import { CardHeader } from '../../../components/CardHeader';

export const UserFinalized = ({ textConfig }: DefaultComponentProps) => {
  const { title, ingress, emoji, emojiLabel, buttonText } = textConfig.userFinalized;
  return (
    <>
      <CardHeader title={title} ingress={ingress} emoji={emoji} emojiLabel={emojiLabel} />
      <CardBody>
        <a className="card__button card__button-filled card__button-grouped" href="/login/">
          {buttonText}
        </a>
      </CardBody>
    </>
  );
};
